export default "__VITE_ASSET__CGLz$qqX__"